
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mailTemplate/create",
      function () {
        return require("private-next-pages/mailTemplate/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mailTemplate/create"])
      });
    }
  